// Steps da tela instrumentos-cognitivos

const steps = [
  {
    selector: '[data-tour="form-informacao"]',
    content: "Deseja criar uma nova avaliação? Tudo bem (Clique em Criar avaliação)"
  },
  {
    selector: '[data-tour="form-informacao2"]',
    content: "Para facilitar sua busca por avaliações, clique aqui!"

  },
  {
    selector: '[data-tour="form-informacao3"]',
    content: "Avaliação , atividade e trilha "

  },
];

export default steps;